export default "__VITE_ASSET__CRuM7Oww__"